import { render, staticRenderFns } from "./JSelectDepartModals.vue?vue&type=template&id=08f1a928&scoped=true"
import script from "./JSelectDepartModals.vue?vue&type=script&lang=js"
export * from "./JSelectDepartModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f1a928",
  null
  
)

export default component.exports